// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3M29u","colCheckbox":"styles_colCheckbox__366oe"};